<template>
    <van-row class="cardContainer">
        <van-col span="5" class="dayColumn">
            <div class="dayImage">
                <img src="@/assets/common/calender.png" alt="">
                <div class="dateText" v-if="props.time">{{ formatUnixTimestamp(props.time)?.split(' ')[0] }}</div>
                <div class="dayText" v-else>{{ props.day }}</div>
            </div>
        </van-col>
        <van-col span="13"
            style="padding:0 10px; display: flex; align-items: center; border-right: 3px dashed #80808070;">
            <van-col span="24">
                <van-row>
                    <van-col span="24" v-if="isShowHistory ? true : checkDate(formatUnixTimestamp(props.time)) == 0">
                        <van-row class="topData">
                            <van-col span="12" class="topCol" style="border-right: 1px solid #80808070;">
                                <div class="toptext">{{ $t('activity.available') }}</div>
                                <div class="toptext">{{ formatCurrency(availableAmount) }}</div>
                            </van-col>
                            <van-col span="12" class="topCol">
                                <div class="toptext">{{ $t('activity.givenAmount') }}</div>
                                <div class="toptext">{{ formatCurrency(givenAmount) }}</div>
                            </van-col>
                        </van-row>
                    </van-col>

                    <van-col span="24" style="padding-left: 5px;">
                        <span
                            v-bind:class="['middle-texts', props.activityStatus == 0 || props.activityStatus == 11 || props.activityStatus == 2 ? 'middle-pending' : '']">
                            <P>{{ $t(props.labelOne!) }}: {{ props.currenyLable ? 'R$' : '' }}
                                {{ props.valueOne }}{{ props.currenyLable ? '' : '%' }}
                            </P>
                            <P>{{ $t(props.labelTwo!) }}: {{ props.valueTwo }}X</P>
                        </span>
                    </van-col>
                </van-row>
            </van-col>
        </van-col>
        <van-col span="6" style="padding-left: 10px; display: flex; align-items: center; justify-content: center; ">
            <div class="claimBtn"
                v-if="isShowHistory ? false : activityStatus == 0 && checkDate(formatUnixTimestamp(props.time)) == 0">
                <div class="click_btn" @click="clickOnButton">
                    {{ $t('activity.click') }}
                </div>
            </div>
            <span class="right-texts" v-else>
                <p v-if="props.activityStatus == 0 && returnTurnover" style="color: #ff0000;">{{
                    $t('activityStatus.noRewards')
                }}</p>
                <p v-else-if="props.activityStatus == 0 || props.activityStatus == 11" style="color: #0484ff;">{{
                    $t('activityStatus.pending') }}</p>
                <p v-else-if="props.activityStatus == 1" style="color: #36d836;">{{ $t('activityStatus.completed') }}
                </p>
                <p v-else-if="props.activityStatus == 2" style="color: #ff0000;">{{ $t('activityStatus.noRewards') }}
                </p>
                <p v-else-if="props.activityStatus == 3" style="color: #ff0000;">{{ $t('activity.overdue')
                    }}</p>
            </span>
        </van-col>

    </van-row>




</template>
<script lang="ts" setup>
import { defineProps, defineEmits } from 'vue';
import { checkDate, formatCurrency, formatUnixTimestamp } from '@/utils/commonFunction';

const props = defineProps({
    day: {
        type: Number
    },
    valueOne: {
        type: Number
    },
    valueTwo: {
        type: Number
    },
    currenyLable: {
        type: Boolean
    },
    labelOne: {
        type: String
    },
    labelTwo: {
        type: String
    },
    time: {
        type: Number,
        default: () => 0
    },
    activityStatus: {
        type: Number
    },
    returnTurnover: {
        type: Boolean,
        default: false
    },
    availableAmount: {
        type: Number,
        default: () => 0
    },
    givenAmount: {
        type: Number,
        default: () => 0
    },
    isShowHistory: {
        type: Boolean,
        default: false
    }
})
const emits = defineEmits(['getClaim'])
const clickOnButton = () => {
    emits('getClaim')
}
</script>
<style scoped>
.cardContainer {
    background: #292a2d;
    border: 2px solid #ffcea6;
    border-radius: 10px;
    padding: 10px 5px;
    color: #fff;
    font-size: 12px;
    margin: 10px 15px 0;
}

.dayColumn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    border-right: 3px dashed #80808070;
    align-items: center;
}

.dayImage img {
    width: 85%;
}

.dayImage {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.day-num {
    position: absolute;
    font-size: 25px;
    white-space: nowrap;
    color: #FFF5D7;
    text-shadow: -1px -1px 0 #300000, 1px -1px 0 #300000, -1px 1px 0 #300000, 1px 1px 0 #300000;
    z-index: 800;
    font-weight: 700;
    left: 55%;
    top: 30%;
}

.dateText {
    position: absolute;
    top: 50%;
    padding: 5px 0;
    font-size: 6px;
    color: #000;
    font-weight: 600;
}

.dayText {
    position: absolute;
    padding: 5px 0;
    top: 45%;
    font-size: 16px;
    color: #000;
    font-weight: 600;
}

.topData {
    border-bottom: 1px solid #80808070;
    margin-bottom: 5px;
    padding: 10px 0;
}

.topCol {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-direction: column;
}

.toptext {
    padding: 5px 0 0;
    font-size: 11px;
}

.coins-img {
    position: absolute;
    right: 0rem;
    top: 35%;
    z-index: 800;
    width: 18%;
}

.div-card {
    width: 100%;
    padding: 0.5rem;
    padding-left: 0rem;
    /* height: 70px; */
}

.middle-texts {}

.middle-pending {
    top: 2vh;
}

.middle-texts p {
    margin: 5px 0px !important;
    font-size: 78%;
}

.right-texts {}

.right-texts p {
    margin: 0px !important;
    font-size: 78%;
    top: 2.5vh;
}

@media (min-width:450px) {
    .day-num {
        font-size: 200%;
        top: 31%;
    }

    .middle-texts {
        left: 22%;
    }

    .right-texts {
        left: 62%;
    }

    .coins-img {
        width: 25%;
        top: 1rem;
    }

    .div-card {
        height: none;
    }

    .middle-texts p {
        font-size: 100%;
    }

    .right-texts p {
        font-size: 100%;
    }

    .dateText {
        font-size: 11px;
    }
}

.click_btn {
    color: #12151A;
    font-size: 11.5px;
    background-image: linear-gradient(rgb(248, 216, 167) 0%, rgb(240, 168, 83) 100%);
    border-radius: 5px;
    padding: 10px;
    display: flex;
    align-items: center;
    display: flex;
    text-align: center;
    justify-content: center;
    /* width: 80%; */
    margin-top: 10px;
}

@media (min-width:350px) {
    .dateText {
        font-size: 8px;
    }
}

@media (min-width: 600px) {
    .dateText {
        font-size: 10px;
    }
}

@media (min-width: 1920px) {
    .dateText {
        font-size: 14px;
    }
}
</style>